import Header from './Header'

export default Header



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/components/Header/index.js